import React, { useMemo, ReactElement, useState, createContext } from 'react';
import { parseLog } from '../components/Logger/utils';

type LoggerContextType = {
	logText: string;
	updateGlobalLog: (arg: object) => string;
};
export const LoggerContext = createContext<LoggerContextType>({
	logText: '',
	updateGlobalLog: () => '',
});

export function LoggerProvider({
	children,
	defaultData = '',
}: {
	children: ReactElement;
	defaultData?: string;
}) {
	const [logText, updateGlobalLog] = useState<string>(defaultData);
	const context = useMemo(
		() => ({
			logText,
			updateGlobalLog: (args: object) => {
				const data = parseLog(args, true);
				return updateGlobalLog(data);
			},
		}),
		[logText]
	) as LoggerContextType;

	return (
		<LoggerContext.Provider value={context}>{children}</LoggerContext.Provider>
	);
}
